import { inject, InjectionToken } from '@angular/core';
import { HeaderRepository } from '@repositories/header.repository';

export const HEADER_REPOSITORY = new InjectionToken<HeaderRepository>(
  'HeaderRepository',
  {
    factory: () => inject(HeaderRepository)
  }
);
